import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
}

/** Só 'hidden' pausa: um valor desconhecido (ou o antigo 'prerender') conta como visível. */
const getSnapshot = (): boolean => document.visibilityState !== 'hidden';

/** Sem `document` (render no servidor), a página conta como visível. */
const getServerSnapshot = (): boolean => true;

/**
 * A aba do navegador está visível? Lê `document.visibilityState` e acompanha o evento
 * `visibilitychange` (precedente: `useTokenExpirationCheck`). O listener sai ao desmontar.
 *
 * Usado pelo polling de status dos Meus Estudos (#2001), que pausa com a aba em segundo plano.
 *
 * @returns `true` com a aba visível; `false` com ela oculta (outra aba, janela minimizada).
 */
export default function usePageVisibility(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
